import { GET_PROFILE_FAILED, GET_PROFILE_REQUESTED, GET_PROFILE_SUCCESS, GET_UPDATEPROFILE_FAILED, GET_UPDATEPROFILE_REQUESTED, GET_UPDATEPROFILE_SUCCESS } from "resources/actionTypes";


const initialState = {
  userProfile: [],
  loading: false,
  error: null,
};
const initialStateUpdate = {
  userUpdateProfile: [],
  loading: false,
  error: null
}

export function userProfile(state = initialState, action) {
  switch (action.type) {
    case GET_PROFILE_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_PROFILE_SUCCESS:
      return {
        ...state,
        loading: false,
        userProfile: action.userProfile,
      };
    case GET_PROFILE_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
}

export function userUpdateProfile(state = initialStateUpdate, action) {
  switch (action.type) {
    case GET_UPDATEPROFILE_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_UPDATEPROFILE_SUCCESS:
      return {
        ...state,
        loading: false,
        userUpdateProfile: action.userUpdateProfile,
      };
    case GET_UPDATEPROFILE_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
}
